module.exports = __webpack_public_path__ + "img/headphones.be5030ca.webp";